
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeVirtualDoctors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseSpecialty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customTag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyAvailableNow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeVirtualDoctors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"baseSpecialty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseSpecialty"}}},{"kind":"Argument","name":{"kind":"Name","value":"customTag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customTag"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyAvailableNow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyAvailableNow"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"llname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"posname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingAvg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primarySpecialty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customTags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOnlineNow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextSchedule"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":532}};
    doc.loc.source = {"body":"query activeVirtualDoctors(\n  $baseSpecialty: String\n  $customTag: String\n  $onlyAvailableNow: Boolean\n  $first: Int\n  $offset: Int\n) {\n  activeVirtualDoctors(\n    baseSpecialty: $baseSpecialty\n    customTag: $customTag\n    onlyAvailableNow: $onlyAvailableNow\n    first: $first\n    offset: $offset\n  ) {\n    id\n    prename\n    fname\n    mname\n    lname\n    llname\n    posname\n    profileUrl\n    avatar\n    imageUrl\n    subname\n    ratingAvg\n    ratingCount\n    primarySpecialty\n    customTags\n    isOnlineNow\n    nextSchedule\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["activeVirtualDoctors"] = oneQuery(doc, "activeVirtualDoctors");
        
